<template>
  <div
    v-if="typesCount && Object.keys(typesCount).length"
    class="daily-total no_mobile"
  >
    <h2 class="title text--28 bold tx--blue no-marge">
      פירוט תורים ל- {{ $moment(selectedDate).format("D בMMMM") }} :
    </h2>
    <ul>
      <li v-for="(count, key) in typesCount" :key="key">
        {{ key }} ({{ count }})
      </li>
    </ul>
    <div class="bold no-print">סה״כ {{ appointmentsDayCount }} תורים</div>
  </div>
</template>

<script>
export default {
  name: "TypesCount",
  props: {
    typesCount: {
      required: true
    },
    appointmentsDayCount: {
      required: true
    },
    selectedDate: {
      required: true
    }
  }
};
</script>
